import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Offcanvas, Button, Form, Alert } from "react-bootstrap";
import { BulkUpload } from "../../slices/hsnSacReducer";
import { extractErrorMessage } from "../../constants/common";
import toast from "react-hot-toast";

const BulkImportOffcanvas = ({ show, onHide, type }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    setFile(null);
  }, [show]);

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      const fileType = uploadedFile.name.split(".").pop().toLowerCase();
      if (fileType !== "xlsx") {
        setError("Only .xlsx files are allowed!");
        setFile(null);
      } else {
        setError("");
        setFile(uploadedFile);
      }
    }
  };

  const handleSubmit = () => {
    if (!file) {
      setError("Please upload a valid .csv file.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("types", type);

    dispatch(BulkUpload({ formData }))
      .unwrap()
      .then(() => {
        onHide();
        setFile(null);
        toast.success("File is processing");
      })
      .catch((error) => {
        const errorMessage = extractErrorMessage(error);
        toast.error(errorMessage);
      });
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      backdrop="static"
      className="bulk-import-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="!text-[24px]">Bulk Import</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group>
            <Form.Label className="!text-base">Upload CSV File</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx"
              onChange={handleFileChange}
            />
            <Form.Text className="text-muted">
              <a
                href="/assets/files/HSN&SACDownloadSample.xlsx"
                download
                style={{ textDecoration: "underline" }}
              >
                Sample File
              </a>
            </Form.Text>
          </Form.Group>

          <div className="d-flex gap-2 justify-content-end mt-3">
            <Button variant="secondary" className="!text-sm" onClick={onHide}>
              Cancel
            </Button>
            <Button
              variant="primary"
              className="!text-sm"
              onClick={handleSubmit}
              disabled={!file}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default BulkImportOffcanvas;